
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { DeviceType, AppModule } from '@/store/modules/app'
import { SettingsModule } from '@/store/modules/settings'
import { AppMain, Navbar, Sidebar } from './components'
import RightPanel from '@/components/RightPanel/index.vue'
import ResizeMixin from './mixin/resize'
import { getEnterprise } from '@/api/universal'

@Component({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    RightPanel,
    Sidebar
  }
})
export default class extends mixins(ResizeMixin) {
  get isMobileH5() {
    return window.screen.availWidth <= 700 && window.screen.availWidth >= 310
  }
  public mobileType: boolean = false

  private dialogVisible: boolean = false
  private currentDomain: any = ''
  private jumpDoain: string = ''
  private h5Url: any = ''
  private getDoain() {
    this.currentDomain = window.location.host
    this.jumpDoain = this.currentDomain.split('manage.')[1]
    // this.h5Url = 'h5.' + this.jumpDoain
    this.h5Url = `${'h5.' + this.jumpDoain}`
  }
  private jump() {
    window.open('https://' + this.h5Url)
  }

  private async getLogo() {
    try {
      await getEnterprise().then((res: any) => {
        if (res.site_logo && res.site_logo !== '') {
          AppModule.SetSiteLogo(res.ssl_switch.site_logo)
          AppModule.SetSiteName(res.ssl_switch.site_name)
          let link: any =
            document.querySelector("link[rel*='icon']") ||
            document.createElement('link')
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          link.href = res.site_logo
          document.getElementsByTagName('head')[0].appendChild(link)
        }
      })
    } catch (e) {}
  }

  created() {
    this.getLogo()
    let flag = window.navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (flag) {
      //如果flag不为空，说明可以匹配到，是手机端
      this.mobileType = true
    } else {
      if (document.body.clientWidth <= 500) {
        this.mobileType = true
      } else {
        this.mobileType = false
      }
    }
  }

  mounted() {
    this.getDoain()
    // if (this.isMobileH5) {
    //   this.dialogVisible = true
    // }
  }

  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile
    }
  }

  get showSettings() {
    return SettingsModule.showSettings
  }

  get showTagsView() {
    return SettingsModule.showTagsView
  }

  get fixedHeader() {
    return SettingsModule.fixedHeader
  }

  private handleClickOutside() {
    AppModule.CloseSideBar(false)
  }
}
